module.exports = __webpack_public_path__ + "static/media/gasoline-banesco-selected.8dcb6efd.svg";